import { z } from 'zod';
import { UlidSchema } from './common.js';
import { MembershipRolSchema } from './admin-invite.js';

/**
 * Tenant en el que el usuario autenticado tiene memberships activos.
 * Retornado por GET /me/tenants.
 */
export const MyTenantSchema = z.object({
  tenantId: UlidSchema,
  rol: MembershipRolSchema,
  nombre: z.string(),
  comuna: z.string(),
});
export type MyTenant = z.infer<typeof MyTenantSchema>;

/**
 * Response para GET /me/tenants.
 */
export const MyTenantListSchema = z.object({
  items: z.array(MyTenantSchema),
});
export type MyTenantList = z.infer<typeof MyTenantListSchema>;
